import {
  LOCATION_CHANGE,
  SCENE_STORAGE,
  DEVICE_STATUS,
  ERROR_HANDLE,
} from "../types";

const routeState = (state = {}, action) => {
  // 路由状态
  if (action.type === LOCATION_CHANGE) {
    return action.payload.location;
  }
  return state;
};

const storageSceneReducer = (state = 0, action) => {
  if (action.type === SCENE_STORAGE) {
    return action.scene;
  }
  return state;
};

const deviceStatusReducer = (state = [], action) => {
  if (action.type === DEVICE_STATUS) {
    return action.status;
  }
  return state;
};

const errorHandleReducer = (state = -1, action) => {
  if (action.type === ERROR_HANDLE) {
    return action.errortype;
  }
  return state;
};

export {
  routeState,
  storageSceneReducer,
  deviceStatusReducer,
  errorHandleReducer,
};
